import { fabricRectToPdfSquare } from './fabricRectToPdfSquare';
import { fabricEllipseToPdfCircle } from './fabricEllipseToPdfCircle';
import { fabricPathToPdfInk } from './fabricPathToPdfInk';
import { fabricLineToPdfInk } from './fabricLineToPdfInk';
import { fabricArrowToPdfLine } from './fabricArrowToPdfLine';
import { fabricTextboxToPdfFreeText } from './fabricTextboxToPdfFreeText';

export const FABRIC_TO_PDF_MAPPERS = {
  line: fabricLineToPdfInk,
  arrow: fabricArrowToPdfLine,
  rectangle: fabricRectToPdfSquare,
  ellipse: fabricEllipseToPdfCircle,
  freehand: fabricPathToPdfInk,
  textbox: fabricTextboxToPdfFreeText,
};
